import { render } from "./MasterSkuRegisterGuide.vue?vue&type=template&id=0b151d5b&scoped=true"
import script from "./MasterSkuRegisterGuide.vue?vue&type=script&lang=js"
export * from "./MasterSkuRegisterGuide.vue?vue&type=script&lang=js"

import "./MasterSkuRegisterGuide.vue?vue&type=style&index=0&id=0b151d5b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b151d5b"]])

export default __exports__